var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"reservoirbg"},[_c('div',{staticClass:"reservoir"},[_vm._v("库区")]),_vm._v(" "),_c('div',{staticClass:"gross"},[_vm._v("存储总量")]),_vm._v(" "),_c('div',{staticClass:"sum"},_vm._l((_vm.storage.sum),function(item,index){return _c('span',{key:index,staticClass:"number"},[_vm._v(_vm._s(item))])}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8828dca2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xiayan/home/home/echarts27.vue
// module id = null
// module chunks = 